import React, { useEffect, useState } from 'react';
import { message, Button, Card, Layout, Typography, Radio, Space, Row, Col, Divider } from 'antd';
import env from '../../../environment';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import numeral from 'numeral';
import { ArrowLeftOutlined, LockOutlined, SafetyOutlined } from '@ant-design/icons';
import { Footer } from 'antd/es/layout/layout';
import CheckOutComponent from '../CheckOutComponent';

const protectedPayment = require('../../../assets/icons/protectedPayment.png');

const { Text } = Typography;

function Payments({}) {
	const { t } = useTranslation();
	const userToken = useSelector((state: any) => state.auth.token);
	const [valueRadio, setValueRadio] = useState(1);
	const { operationId } = useParams();
	const navigate = useNavigate();
	const [showCheckout, setShowCheckout] = useState(false);
	const [dataClient, setDataClient] = useState<any>('');
	const [mortgage, setMortgage] = useState<any>(undefined);

	const backToDocuments = () => {
		navigate(`/operations/${operationId}/documents`);
	};

	useEffect(() => {
		getTokenPay();
		getDataOperation();
	}, []);

	const getDataOperation = () => {
		axios
			.get(`${env.api.url}/v1/operations/${operationId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setMortgage(response.data.data);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const getTokenPay = () => {
		axios
			.post(
				`${env.api.url}/v1/payments/appraisal/checkout`,
				{
					operationId: operationId
				},
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then((response) => {
				setDataClient(response.data.data);
			})
			.catch((e) => {
				console.log(e);
			});
	};

	return (
		<Layout style={{ padding: 16, marginBottom: 200 }}>
			<Space
				onClick={() => backToDocuments()}
				style={{ color: '#212121', fontSize: 16, cursor: 'pointer' }}>
				<ArrowLeftOutlined />
				<Text style={{ fontSize: 16, fontWeight: 600, color: '#212121' }}>
					{t('viability.back')}
				</Text>
			</Space>
			<div style={{ marginTop: 16 }}>
				<Text style={{ fontSize: 16, fontWeight: 600, color: '#212121', marginTop: 16 }}>
					{t('payments.pending')}
				</Text>
			</div>
			{mortgage && (
				<CheckOutComponent
					userMortgageId={operationId}
					amount={mortgage?.operationData?.mortgage?.appraisalAmount}
					showPayBoolean={showCheckout}
					mortgageId={operationId}
					clientSecretToken={dataClient?.paymentSeat?.session?.client_secret}
					dataClient={dataClient}
					firtsPaydocuments={true}
					setshowCheckout={setShowCheckout}
					setModalPay={undefined}
					getDataOperation={getDataOperation}
				/>
			)}
			<div style={{ width: '100%', background: '#ffffff' }}>
				<Divider
					type="horizontal"
					style={{ color: '#C0DAEE', width: '100%', marginBottom: 8 }}></Divider>
				<div style={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center' }}>
					<div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
						<LockOutlined style={{ color: '#757575', fontSize: 18 }} alt="icono de candado" />
						<Text style={{ fontSize: 12, fontWeight: 400, color: '#757575' }}>
							{t('doc.ourSecureInformation').replace(/:$/, '.')}
						</Text>
					</div>
					<div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
						<SafetyOutlined
							style={{ color: '#757575', fontSize: 18 }}
							alt="icono de pago protegido"
						/>
						<div>
							<Text style={{ fontSize: 12, fontWeight: 400, color: '#757575' }}>
								{t('appraisal.protectedPayment')}
							</Text>
						</div>
					</div>
				</div>
			</div>
		</Layout>
	);
}

export default Payments;
